
import React from 'react';
import styles from './Toastr.module.scss';

interface ToastrProps {
  message: string;
  isVisible: boolean;
  onClose?: () => void;
  backgroundColor?: string;
  closeTime?: number;
}

const Toastr: React.FC<ToastrProps> = ({ message, isVisible, onClose, backgroundColor = 'white', closeTime = 1500}) => {
  React.useEffect(() => {
    if (isVisible && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, closeTime);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div onClick={onClose} className={styles.toastr} style={{ backgroundColor: backgroundColor }}>
      {message}
    </div>
  );
};

export default Toastr;
